// Polyfills loaded before any other module — including the react-snap
// pre-render pass, whose bundled Chromium predates some modern APIs.

// Promise.withResolvers — required by pdf.js (via react-pdf). Absent in
// browsers and Chromium builds older than ~2024.
if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// URL.parse — also used by pdf.js. Static method added to browsers in 2024.
if (typeof URL.parse !== 'function') {
  URL.parse = function parse(url, base) {
    try {
      return base !== undefined ? new URL(url, base) : new URL(url);
    } catch (e) {
      return null;
    }
  };
}
